import { Modal, AsyncSelect } from "components";
import { Button, Input } from "expano-components";
import getNotBundleProducts from "utils/select_options/getNotBundleProducts";
import useUpdate from "hooks/useUpdate";
import { useState } from "react";

const EditBundle = ({
  product_component_id,
  initial_component_id,
  component_default_value,
  initial_quantity,
  refetch,
  handleClose,
}) => {
  const [component_id, setBundleId] = useState(initial_component_id);
  const [quantity, setQuantity] = useState(initial_quantity);

  const { is_updating, update } = useUpdate({
    path: `/product_components/${product_component_id}`,
    onSuccess: () => [refetch(), handleClose()],
  });

  const handleCreate = () => update({ component_id, quantity });

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Aktualizuj product powiązany",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            disabled={!component_id || !quantity || is_updating}
            onClick={handleCreate}
          />
        </>
      }
    >
      <AsyncSelect
        label="Wybierz produkt, który będzie częścią bundla:"
        getData={(q) => getNotBundleProducts(q)}
        onChange={({ value }) => setBundleId(value)}
        initValue={component_default_value}
      />
      <Input
        label="Ilość"
        type="number"
        input={{
          name: "quantity",
          value: quantity,
          onChange: ({ target: { value } }) => setQuantity(value),
        }}
        meta={{}}
      />
    </Modal>
  );
};

export default EditBundle;
